module.exports = __webpack_public_path__ + "img/view_calendar_icon.7af1b07d.png";